import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {

  constructor(
    @Inject(PLATFORM_ID) private _platformId:Object
  ){}
  actionCards = [
    {
      title: 'about.action_title1',
      description: 'about.action_desc1',
      buttons: ['about.action_button1', 'about.action_button2'],
      isActive:false
    },
    {
      title: 'about.action_title2',
      description: 'about.action_desc2',
      buttons: ['about.action_button3'],
      rediretLink:"https://apply.pepeunchained.com/form",
      isActive:true
    },
    {
      title: 'about.action_title3',
      description: 'about.action_desc3',
      buttons: ['about.action_button4'],
      isActive:false
    }
  ];

  stats = [
    {
      value: 'about.stats1',
      label: 'about.label1',
      updated: 'about.time1'
    },
    {
      value: 'about.stats2',
      label: 'about.label2',
      updated: 'about.time2'
    },
    {
      value: 'about.stats3',
      label: 'about.label2',
      updated: 'about.time3'
    }
  ];

  imagePaths = [
    '/assets/images/svg-icons/feature1.svg',
    '/assets/images/svg-icons/feature2.svg',
    '/assets/images/svg-icons/feature3.svg',
    '/assets/images/svg-icons/feature4.svg',
     '/assets/images/svg-icons/feature5.svg'
  ];

  handleBtnClick(link:string | undefined) {
    if(link && isPlatformBrowser(this._platformId)) {
      window.open(link , "_blank")
    }
  }
}
